import React from 'react'
import { formatInTimeZone, getTimezoneData } from '@chilipiper/date-time'

type Props = {
  date: { end: string; start: string }
  timezone: string
}

export const DisplayDate = ({ date, timezone }: Props) => {
  return (
    <>
      {getDate(date, timezone)}
      <br />
      {getTime(date, timezone)} {getAbbreviation(date, timezone)}
    </>
  )
}

export const formatDate = (date: { end: string; start: string }, timezone: string) => {
  return `${getDate(date, timezone)} ${getTime(date, timezone)} ${getAbbreviation(date, timezone)}`
}

const getDate = (date: { end: string; start: string }, timezone: string) => {
  return `${formatInTimeZone(new Date(date.start), timezone, 'EEEE, MMM d,')}`
}

const getTime = (date: { end: string; start: string }, timezone: string) => {
  return `${formatInTimeZone(new Date(date.start), timezone, 'h:mm a')} - ${formatInTimeZone(new Date(date.end), timezone, 'h:mm a')}`
}

const getAbbreviation = (date: { end: string; start: string }, timezone: string) => {
  return `${getTimezoneData(timezone, new Date(date.start))?.abbreviation}`
}
